import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery md:grid md:grid-cols-3 my-2"
}
const _hoisted_2 = {
  key: 0,
  class: "card border-0",
  style: {"height":"200px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "md:col-span-3 mt-4 flex"
}
const _hoisted_5 = {
  key: 1,
  class: "gallery-navi-option disabled"
}
const _hoisted_6 = {
  key: 3,
  class: "gallery-navi-option disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.gallery.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            (item.display == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: item.url
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.gallery.length > 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.isEnabledGalleryPreviousButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "gallery-navi-option",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
                  ]))
                : (_openBlock(), _createElementBlock("button", _hoisted_5, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
                  ])),
              (_ctx.isEnabledGalleryNextButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "gallery-navi-option",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                  ]))
                : (_openBlock(), _createElementBlock("button", _hoisted_6, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}